import { Shadows } from '../../theme'

export default {
  headerCard: {
    display: 'inline-block',
    width: '100%',
    textAlign: 'center',
    boxShadow: `${Shadows.primaryShadow}, ${Shadows.secondaryShadow}`
  },
  headerTabContainer: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    paddingRight: 27,
    display: 'flex',
    alignItems: 'flex-end'
  },
  headerButtons: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 20,
    '& > :not(:last-child)': {
      marginRight: 8
    }
  }
}



// WEBPACK FOOTER //
// ./src/styles/components/header.js